<div height-100 flex-column flex class="ion-justify-content-between">
  <div>
    <app-sub-header-text
      title="{{ 'COMPONENTS.FORMS.SUBSCRIPTIONS' | translate }}"
      subtitle="{{ 'COMPONENTS.FORMS.INSERT_THE_SURVEYORS' | translate }}"
    >
    </app-sub-header-text>
    <div class="ion-margin-top">
      <div padding-horizontal-half>
        <ion-label color="primary-dark">
          {{ 'COMPONENTS.FORMS.SURVEYOR_SIGNATURE' | translate }} </ion-label
        ><br />
        <app-signature-button
          [signature]="surveyorSignature"
          (addSignature)="showModal(true)"
        ></app-signature-button>
      </div>

      <div padding-horizontal-half>
        <ion-label color="primary-dark">
          {{ 'COMPONENTS.FORMS.RESPONSIBLE_SIGNATURE' | translate }} </ion-label
        ><br />
        <app-signature-button [signature]="responsibleSignature" (addSignature)="showModal(false)">
        </app-signature-button>
      </div>

    </div>
  </div>
  <div>
    <div class="ion-text-end ion-padding" max-width>
      <ion-button class="ion-margin-start" responsive-button color="buttonPrimary" (click)="submit()">{{
        'COMPONENTS.FORMS.SEND_SIGNATURES' | translate
      }}</ion-button>
    </div>
  </div>
</div>
